import {gql} from 'apollo-angular';

export const GET_ALL_FAQ_CATEGORIES = gql`
  query GetAllFaqCategories {
    faqCategories {
      categoryName
      subcategories {
        subCategoryName
        questions {
          question
          answer
        }
      }
    }
  }
`;
